import React, { Fragment, useMemo } from 'react';
import AutocompleteFilter from '../common/autocompleteFilter';
import utilFunction from '../../containers/function';

const Buttons = (props) => {
  // Memorize role options to avoid unnecessary recalculations
  const roleOptions = useMemo(() => {
    // create role autocomplete options
    let options = props.roles.map((value) => {
      const roleDescription = props.language.account.accountUser[value.roleName.toLowerCase()];

      return ({
        key: value.roleName,
        value: roleDescription ? roleDescription : value.roleName
      })
    });
    options = utilFunction.sortByField(options, 'value', 'ASC');

    // add "All" option to the beginning of the list
    options.unshift({
      key: '*',
      value: props.language.all
    });

    return options;
  }, [props.roles, props.language]);

  return (
    <section className="module-filter top">
      <div className="flex">
        <div className="flex filter-box">
          <h2 id="select-filter" className="container-filter-h2 column-filter">
            <span>{props.language.account.filterDriver.show}:</span>
            <div>{props.language.account.accountUser.activateUsers}</div>
          </h2>
          <ul className="container-filter-ul">
            <li className="container-filter-li">
              <i className="fas fa-caret-down" />
              <ul>
                <li data-select="c" onClick={props.handleUserFilter}>
                  {props.language.account.accountUser.activateUsers}
                </li>
                <li data-select="b" onClick={props.handleUserFilter}>
                  {props.language.account.accountUser.deactivateUsers}
                </li>
                <li data-select="a" onClick={props.handleUserFilter}>
                  {props.language.account.accountUser.allUsers}
                </li>
              </ul>
            </li>
          </ul>
        </div>
        {props.filter.map((item, i) => {
          // create options for autocomplete
          const options = item.tags.map((value) => ({
            key: value.tag,
            value: value.tag
          }));
          // add "All" option to the beginning of the list
          options.unshift({
            key: '*',
            value: props.language.all
          });

          return (
            <AutocompleteFilter
              key={`autocompleteFilter-key-${i}`}
              id={`select-filter-${item.name}`}
              label={props.language.filter[item.name.toLowerCase()]}
              selectedKey={'*'}
              options={options}
              onChange={props.handleTagsFilter}
              dataAttributes={{
                "data-select": (option) => option.key,
                "data-category": item.name.toLowerCase(),
                "data-parent": `select-filter-${item.name}`,
              }}
            />
          );
        })}
        <AutocompleteFilter
          id="select-roles"
          label={props.language.account.accountUser.userRoleTitle}
          selectedKey={'*'}
          options={roleOptions}
          onChange={props.handleRolesFilter}
          dataAttributes={{
            "data-select": (option) => option.key,
            "data-name": 'Permisos',
            "data-parent": 'select-roles',
          }}
        />
      </div>
      <div className="flex flex-direction-row">
        <div>
          <ul className="buttom_menu button_menu__container">
            <li>
              <a data-close="ok" id="accountUser-button-createUser" onClick={props.handleModal}>
                {props.language.account.accountUser.createUser}
              </a>
            </li>
          </ul>
        </div>
        <div className="box-form">
          <ul className="buttom_menu button_menu__container">
            <li className="button_menu__container-dark">
              {props.language.account.accountUser.massiveActions}
              <ul>
                <li>
                  <a className="flex align-center justify-space-between">
                    <div data-close="ok" id="accountUser-button-import" onClick={props.handleModalUpdate}>
                      {props.language.account.createDriver.importUsers}
                    </div>
                    <i className="fas fa-upload" />
                  </a>
                </li>
                <li>
                  <a className="flex align-center justify-space-between">
                    <div data-close="ok" id="accountUser-button-download" onClick={props.handleModalDownload}>{props.language.account.createDriver.download}</div>
                    <i className="fas fa-download" />
                  </a>
                </li>

                {
                  // If you are a super admin, you can see these options to associate users-drivers
                  (props.root === 'true') && (
                    <Fragment>
                      <li>
                        <div className="divider"></div>
                      </li>
                      <li>
                        <a className="flex align-center justify-space-between">
                          <div data-close="ok" onClick={props.handleModalUpdateAssociateUsers}>
                            {props.language.account.createDriver.associateUsers}
                          </div>
                          <i className="fas fa-users" />
                        </a>
                      </li>
                      <li>
                        <a className="flex align-center justify-space-between">
                          <div data-close="ok" onClick={props.handleModalDownloadAssociateUsers}>
                            {props.language.account.createDriver.download}
                          </div>
                          <i className="fas fa-download" />
                        </a>
                      </li>
                    </Fragment>
                  )
                }
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
};

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/account_user/buttons.jsx